import Masonry from 'masonry-layout'
import {breakpointDown, breakpointUp} from "./breakpoints";
import {updateSmoothScroll} from "../scroll-smoother";

// To use add class js-auto-masonry-grid to container and class js-masonry-grid-el to inside colons for auto generating grid
// can add attributes data-min-width  data-max-width
// column width add in css with percents

export class MasonryGrid {

  constructor($block, itemSelector = '.js-masonry-grid-el') {

    this.block = $block
    this.minWidth = this.block.data('min-width') ?? 'xs'
    this.maxWidth = this.block.data('max-width') ?? ''
    this.itemSelector = itemSelector

    this.grid = ''
    let self = this

    setTimeout(function(){
      self.init()
    }, 400)

  }

  init(){

    if (breakpointUp(this.minWidth) && breakpointDown(this.maxWidth)) {

      this.grid = new Masonry(this.block[0], {
        itemSelector: this.itemSelector,
        percentPosition: true
      });

      updateSmoothScroll()

    }

  }


  destroy(){

    this.grid.destroy()

  }


  append($elements){

    this.grid.appended($elements)
    this.grid.layout()

  }


}

$(window).on("load", function () {
  $('.js-auto-masonry-grid').each(function () {
    new MasonryGrid($(this))
  })

})
